@if (!resource()) {
  <nb-card class="loading">
    <nb-card-body>
      @if (isLoading()) {
        <nb-spinner></nb-spinner>
      }
    </nb-card-body>
  </nb-card>
}

@if (resource()) {
  <router-outlet></router-outlet>
}

